<template>
  <cms-base-button-simple
    v-bind="props"
    :disabled="isAlreadyEnrolled"
    :text="buttonText"
    @click="handleAction()"
  />
</template>

<script lang="ts" setup>
import type { TargetEnroll } from '#types/target'

const props = defineProps<TargetEnroll>()

const route = useRoute()
const router = useRouter()
const auth = useAuthStore()
const user = useUserStore()
const toast = useToaster()
const { $t } = useNuxtApp()
const { DialogSignIn } = useDialogsStore()

const campaignName = computed(() => props.actionLink?.campaignName || route.query.enrollment_marketing_source as string)

const isAlreadyEnrolled = computed(() => {
  const details = user.details as any

  return auth.loggedIn && !!campaignName.value && (
    details?.lastSourceUpdate?.campaignName === campaignName.value
    || details?.source?.campaignName === campaignName.value
  )
})

const buttonText = computed(() => {
  if (isAlreadyEnrolled.value) return props.actionLink?.enrolled || $t.signUp
  return auth.loggedIn
    ? (props.actionLink?.signedIn || $t.signUp)
    : (props.actionLink?.signedOut || $t.signIn)
})

const handleAction = async () => {
  if (auth.loggedIn) {
    if (campaignName.value) {
      try {
        await user.updateBasicInfo({ source: { campaignName: campaignName.value } })
      }
      catch {
        toast.add({
          props: {
            type: 'error',
            message: $t.somethingWentWrong,
          }
        })
      }
    }
    return
  }

  if (props.actionLink?.campaignName) {
    await router.replace({
      query: { ...route.query, enrollment_marketing_source: props.actionLink.campaignName }
    })
  }

  DialogSignIn.open()
}
</script>
